module.exports = {
      id: "google-plain-color-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-b468923450c663eeca769f8899a6b186.svg#google-plain-color",
      toString: function () {
        return this.url;
      }
    }